// React
import React, { Children } from "react";

// External libraries
import {useAutoAnimate} from "@formkit/auto-animate/react";

import "./forms.css";

function FormSection(props) {
    const [body, enableAnimations] = useAutoAnimate();
    
    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    if (props.Skeleton) {
        const columns = Children.toArray(props.children);
        return columns.map((column, index) => {
            return (
                React.cloneElement(column, { key: index, Skeleton: true })
            );
        });
    }

    if (props.Animate) {
        return (
            <div className="eone-ui-form-section" ref={body}>
                {props.children}
            </div>
        );
    }
    
    return (
        <div className="eone-ui-form-section">
            {props.children}
        </div>
    );
}

export {FormSection};